type SwiperOptions = import('swiper').SwiperOptions
type PaginationOptions = import('swiper').PaginationOptions

declare const Swiper: any

import LayoutManager from './LayoutManager'
import ResponsiveProperty from '../data/ResponsiveProperty'

const $ = jQuery

interface SliderLayoutManagerOptions {
    columns: ResponsiveProperty,
    columnGap: number,
    loop: boolean,
    autoplay: boolean,
    autoplayDelay?: number,
    pagination: boolean,
    paginationType?: 'bullets'|'fraction'|'progressbar'|'numbers',
    paginationClickable?: boolean,
    navigationButtons: boolean,
    transition: 'slide'|'fade'|'cube'|'coverflow'|'flip'
}

class SliderLayoutManager extends LayoutManager {

    initialized: boolean

    options: SliderLayoutManagerOptions
    
    swiperWrapper: JQuery
    swiper: any

    views: JQuery[]
    
    constructor(itemGrid) {
        super(itemGrid)

        this.options = itemGrid.data('options')
        this.swiperWrapper = $('<div class="swiper-wrapper"/>')
        itemGrid.append(this.swiperWrapper)

        if (this.options.pagination) {
            const pagination = $('<div class="swiper-pagination"/>')
            itemGrid.append(pagination)
        }

        if (this.options.navigationButtons) {
            const prevButton = $('<div class="swiper-button-prev"/>')
            itemGrid.append(prevButton)
            const nextButton = $('<div class="swiper-button-next"/>')
            itemGrid.append(nextButton)
        }

        const swiperOptions: SwiperOptions = {
            loop: this.options.loop,
            slidesPerView: this.options.columns.mobile.value,
            slideClass: 'grid-item',
            setWrapperSize: true,
            effect: this.options.transition,
            spaceBetween: this.options.columnGap || 0
        }
        const breakpoints = {}
        breakpoints[this.options.columns.tablet.breakpoint] = {
            slidesPerView: this.options.columns.tablet.value || 1
        }
        breakpoints[this.options.columns.desktop.breakpoint] = {
            slidesPerView: this.options.columns.desktop.value || 1
        }
        swiperOptions.breakpoints = breakpoints
        if (this.options.pagination) {
            const pagination: PaginationOptions = {
                el: '.swiper-pagination'
            }

            if (this.options.paginationType === 'numbers') {
                pagination.type = 'bullets'
                pagination.renderBullet = function(index: number, className: string) {
                    return `<span class="${className}">${index + 1}</span>`
                }
                pagination.bulletClass = 'swiper-pagination-number'
                pagination.bulletActiveClass = 'swiper-pagination-number-active'
            } else {
                pagination.type = this.options.paginationType
            }
            if (pagination.type === 'bullets') {
                pagination.clickable = this.options.paginationClickable
            }
            swiperOptions.pagination = pagination
        }

        if (this.options.navigationButtons) {
            swiperOptions.navigation = {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            }
        }

        if (this.options.autoplay) {
            swiperOptions.autoplay = {
                delay: this.options.autoplayDelay
            }
        }
        
        this.swiper = new Swiper(this.itemGrid.get(0), swiperOptions)
    }
    
    onPreUpdate() {
        this.views = []
    }
    
    addItem(itemView: JQuery) {

    }

    layoutItem(itemView: JQuery, position: number) {
        this.views[position] = itemView
    }

    removeItem(itemView: JQuery) {

    }

    onPostUpdate() {
        this.swiper.removeAllSlides()
        for (let i = 0; i < this.views.length; i++) {
            const view = this.views[i]
            this.swiper.appendSlide(view.get(0))
        }
        let currentColumns = this.options.columns.mobile.value
        if (window.innerWidth > this.options.columns.tablet.breakpoint) {
            currentColumns = this.options.columns.tablet.value
        }
        if (window.innerWidth > this.options.columns.desktop.breakpoint) {
            currentColumns = this.options.columns.desktop.value
        }
        this.swiper.slideTo(currentColumns, 0, false)

        // slideTo counts as interaction so we have to restart autoplay here
        if (this.options.autoplay) {
            this.swiper.autoplay.start()
        }
    }
}

export default SliderLayoutManager